<template>
  <a-locale-provider :locale="zhCN">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
import enquireScreen from "./utils/device";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
    name: "App",
    data() {
        return {
            zhCN
        };
    },
    created() {
        let _this = this;
        enquireScreen(isMobile => {
            _this.$store.commit("setting/setDevice", isMobile);
        });
    }
};
</script>

<style lang="less">
html,
body {
    min-width: 1280px;
}
:global {
    //拖拽控件全局样式
    .dragable-ghost {
        border: 1px dashed #aaaaaa;
        opacity: 0.65;
    }
    .dragable-chose {
        border: 1px dashed #aaaaaa;
        opacity: 0.65;
    }
    .dragable-drag {
        border: 1px dashed #aaaaaa;
        opacity: 0.65;
    }
    //页面切换动画
    .page-toggle-enter-active {
        transition: all 0.2s ease-in 0.25s;
    }
    .page-toggle-leave-active {
        transition: all 0.2s ease-out 0s;
    }
    .page-toggle-enter,
    .page-toggle-leave-to {
        opacity: 0;
        padding: 0px;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
        white-space: nowrap;
        padding: 9px 13px;
    }
    body,
    .ant-card,
    .ant-table {
        font-size: 13px;
    }

    .f-clearfix {
        zoom: 1;
        &:before,
        &:after {
            content: " ";
            display: table;
        }
        &:after {
            clear: both;
            visibility: hidden;
            font-size: 0;
            height: 0;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue